<template>
  <el-popover
    v-model="popVisible"
    placement="bottom-start"
    trigger="click"
    transition="none"
    popper-class="popper-box__padding-16"
  >
    <template #reference>
      <slot name="reference">
        <IconHc
          class="g__common-btn ml05"
          :class="refClassObj"
          type="icon-bianji"
        />
      </slot>
    </template>

    <div>
      <div>
        <el-form>
          <el-form-item label="">
            <AmountInput
              :size="size"
              :amount.sync="amount"
              :decimal="decimal"
              :disabled="disabled"
              :currencySymbol="currencySymbol"
              :width="120"
              :placeholder="placeholder"
            ></AmountInput>
          </el-form-item>
        </el-form>
      </div>

      <div style="text-align: right;margin-top: 8px;">
        <ElButton type="default" size="mini" @click="handleCancel">取消</ElButton>
        <ElButton type="primary" size="mini" @click="handleConfirm">确定</ElButton>
      </div>
    </div>
  </el-popover>
</template>

<script>
import AmountInput from '@/components/AmountInput/index.vue'

export default {
  components: {
    AmountInput,
  },
  props: {
    currencySymbol: {
      type: [String],
    },
    defaultAmount: {
      type: [Number, String],
      default: 0,
    },
    decimal: {
      type: Number,
      default: 2,
    },
    size: {
      type: String,
      default: 'small',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tableHoverShow: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '请输入金额',
    },
  },
  emits: ['comfirm', 'confirm', 'cancel'],
  data() {
    return {
      amount: 0,
      popVisible: false,
    }
  },
  computed: {
    refClassObj() {
      return {
        'tb-hover-show': this.tableHoverShow
      }
    }
  },
  methods: {
    handleConfirm() {
      this.popVisible = false
      this.$emit('comfirm', this.amount)
      this.$emit('confirm', this.amount)
    },
    handleCancel() {
      this.popVisible = false
      this.$emit('cancel')
    }
  },
  created() {
    this.amount = Number(this.defaultAmount)
  },
}
</script>

<style lang="scss" scoped></style>
